import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "layout/dictionarySearch/folder/byFolder/categories/Header";
import InfiniteGrid from "components/Grid";
import Category from "layout/dictionarySearch/Category";
import Item from "layout/dictionarySearch/Item";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { hoverSame, unhoverSame } from "utils";
import { setScrollbarPlaceholderForCategories } from "utils/dictionarySearch";
import { getIsCycle } from "utils/discovery";

const Categories = ({ categoriesRef, documentsRef }) => {
  const outerListRef = useRef(undefined);
  const innerListRef = useRef(undefined);
  const isCycle = useMemo(getIsCycle, []);

  const [rows, setRows] = useState([]);
  const dictionary = useSelector(
    (state) => state.dictionarySearch.folder.dictionary
  );
  const categories = useSelector(
    (state) => state.dictionarySearch.folder.dictionary.categories
  );

  // using Array.reduce method to avoid stack overflow exceptions when using Math library on large arrays
  const maxOccurrences = categories?.reduce(
    (max, current) => Math.max(max, current.occurrences),
    0
  );

  useEffect(() => {
    const result = [];
    categories.forEach((category) => {
      result.push(
        <Category
          category={category}
          maxOccurrences={maxOccurrences}
          alignCollapseButtonToRight
        />
      );
      if (category.expanded) {
        category.items?.forEach((item) => {
          result.push(<Item item={item} />);
        });
      }
    });
    setRows(result);
  }, [categories]);

  const renderRow = ({ rowIndex, style }) => {
    return (
      <div
        style={style}
        className={`item item-${rowIndex}`}
        onMouseOver={() => hoverSame(rowIndex)}
        onFocus={() => hoverSame(rowIndex)}
        onMouseOut={unhoverSame}
        onBlur={unhoverSame}
      >
        {rows[rowIndex]}
      </div>
    );
  };

  const handleScroll = (scrollTop) => {
    setScrollbarPlaceholderForCategories(categoriesRef, documentsRef);

    if (documentsRef.current && !isCycle(scrollTop)) {
      documentsRef.current.scrollTo({ scrollTop });
    }
  };

  return (
    <div className="categories" data-testid="categories-pane">
      <Header dictionary={dictionary} categoryCount={categories.length} />
      <div className="categories__body" data-testid="categories-body">
        <InfiniteGrid
          listRef={categoriesRef}
          rowSize={26}
          outerRef={outerListRef}
          innerRef={innerListRef}
          rowCount={rows.length}
          onScroll={(_, scrollTop) => handleScroll(scrollTop)}
          renderRow={renderRow}
          columnCount={1}
          hiddenScrollbar
        />
      </div>
    </div>
  );
};

export default Categories;

Categories.propTypes = {
  categoriesRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  documentsRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};
